import React from "react";
import { Alert, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import AgreementTemplatesLayout from "./AgreementTemplatesLayout";
import TemplateList from "./TemplateList";
import UploadWizard from "./UploadWizard";
import PositionEditor from "./PositionEditor";

const AgreementTemplates = () => {
	const roleFromState = useSelector((state) => state.role);
	const isAdminFlag = useSelector((state) => state.isAdmin);
	const role = roleFromState || (isAdminFlag === 1 ? "admin" : "manager");

	if (role !== "admin") {
		return (
			<Box m={2}>
				<Alert severity="warning">Only admins can manage agreement templates.</Alert>
			</Box>
		);
	}

	return (
		<Box m="20px">
			<Routes>
				<Route element={<AgreementTemplatesLayout />}>
					<Route index element={<TemplateList key="landlord" templateType="landlord" />} />
					<Route path="tenant" element={<TemplateList key="tenant" templateType="tenant" />} />
					<Route path="new" element={<UploadWizard templateType="landlord" />} />
					<Route path="tenant/new" element={<UploadWizard templateType="tenant" />} />
					<Route path=":templateId/edit" element={<PositionEditor templateType="landlord" />} />
					<Route path="tenant/:templateId/edit" element={<PositionEditor templateType="tenant" />} />
				</Route>
				<Route path="*" element={<Navigate to="/agreement-templates" replace />} />
			</Routes>
		</Box>
	);
};

export default AgreementTemplates;
